import { h, Fragment } from "preact"; /** @jsx h */

import { timestampStringInEnglish } from '@pyqml/shared';
import { type IWiki, Wiki, Paywalled, type IPassage, Passage } from "@pyqml/model";
import { ROUTES } from '@pyqml/shared';
import { useEnvironment } from "../app/Environment";

import { Header, IHeaderProps } from "../components/Header";


import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';
import { BlogCover } from '../components/BlogCover';

import { WikiProvider } from "../provider/WikiProvider";
import { Content } from "../components/Content";
import { ContentItem } from "../components/ContentItem";



export type IWikiProps = {
	draft: boolean | undefined;
    
} & IHeaderProps;




export const WikiPage = (props: IWikiProps) => {
   
    const { baseUrl, imageUrl, subdomain } = useEnvironment();
    
    
    return <WikiProvider  draft={props.draft}>
    {
        // @ts-ignore
        (wiki: Wiki.IWiki | Array<Wiki.IWiki>, paywalled: Paywalled.IPaywalled) => {
            

            // when we have no slug, show the Intro into the wiki
            if (wiki instanceof Array) {
                return (
                    <Layout.Stacked>
                        <Fragment as="Section">
                            <BlogCover  title="The PyQML Knowledge Base" subtitle="Explore the concepts of Quantum Computing and Quantum Machine Learning" />
                            
                            
                        </Fragment>
                        
                        <Layout.Section weight="equal">
                            <Subheader title="Latest Updates" />
                            <List.Standard>
                            {
                                wiki?.filter((w: IWiki) => w.slug !== "pyqml" && w.slug !== "comics").map((w: IWiki) => (
                                    <List.Item
                                        title={ w.title }
                                        abstract={ w.abstract }
                                        image={ w.abstractImage ? `${imageUrl}/${w.abstractImage}` : undefined}
                                        linkTo={ `${baseUrl}${ROUTES.BLOG_WIKI}/${w.slug}` }
                                        authorLinkTo="./frank"
                                        authorName="Dr. Frank Zickert"
                                        publishedAt={ timestampStringInEnglish( w.orig_revision ? w.orig_revision : w.revision ) }
                                        readingTime={ w.readingTime ?? undefined }
                                    />
                                ))
                            }
                            
                            </List.Standard>
                        </Layout.Section>

                    </Layout.Stacked>
                )
            } else if (wiki instanceof Object) {
                return (
                    <Layout.FixedColumn>
                        <Fragment as="Section" weight="teaser">
                            <BlogCover  title={wiki.title} subtitle={wiki.subtitle} />
                        </Fragment>

                        
                        <Layout.Section weight="full" >
                            {
                                wiki.abstractImage && <div className="container pt-4 pb-4">
                                    <div className="row justify-content-center">
                                        <img src={ `/${subdomain}/${wiki.abstractImage}`}></img>    
                                    </div>
                                </div>
                            
                            }
                        </Layout.Section>

                        <Layout.Section weight="full" >
                            <Content weight="full">
                                
                                <ContentItem contentId={"contentElement"} text={wiki?.content ?? ""} paywalled={paywalled?.paywalledContent ?? ""} />
                                
                            
                            </Content>
                        </Layout.Section>
                        
                        
                        { wiki?.aspects?.length > 0 && <Layout.Fixed>
                            <Subheader title={`Parts of ${wiki.title}`}/>
                            <List.Standard>
                            {
                                    wiki?.aspects?.map((aspect: IWiki) => (
                                        <List.Item
                                            title={ aspect.title }
                                            abstract={ aspect.abstract }
                                            image={ aspect.abstractImage ? `${imageUrl}/${aspect.abstractImage}` : undefined}
                                            linkTo={ `${baseUrl}${ROUTES.BLOG_WIKI}/${aspect.slug}` }
                                            
                                        />
                                    ))
                                }
                                
                            </List.Standard>
                            
                        
                        </Layout.Fixed>}

                        {
                            wiki.passages?.length > 0 && <Layout.Section weight="full">
                                <Subheader title={`More about ${wiki.title}`}/>
                                <List.Standard>
                                {
                                        wiki?.passages?.map((passage: IPassage) => (
                                            <List.Item
                                                title={ passage.title }
                                                abstract={ passage.abstract }
                                                image={ passage.abstractImage ? `${imageUrl}/${passage.abstractImage}` : undefined}
                                                linkTo={ `${baseUrl}${ROUTES.BLOG_WIKI}/${wiki.slug}/${passage.slug}` }
                                                
                                            />
                                        ))
                                    }
                                    
                                </List.Standard>
                            </Layout.Section>
                        }
                        


                    </Layout.FixedColumn>
    
                )


            } else {
                return <div>Loading...</div>
            }
        }
    }
    </WikiProvider>
}


/**
                         * 
                         * 
                        <Layout.Section weight="equal">
                            <Subheader title="Read next" />
                            <Layout.Column>
                            {
                                pagesInCategory && <List.Promoted>{
                                    pagesInCategory?.map((page: Page.IPage) => (
                                        <List.Item
                                            title={ page.title }
                                            abstract={ page.abstract }
                                            image={ page.abstractImage}
                                            linkTo={ page.slug }
                                            authorLinkTo="./frank"
                                            authorName="Dr. Frank Zickert"
                                            publishedAt={ timestampStringInEnglish(page.revision) }
                                            readingTime={ page.readingTime ?? undefined }
                                        />
                                    ))
                                }</List.Promoted>
                            }
                            </Layout.Column>
                            <Layout.Column>
                            {
                                pagesNotInCategory && <List.Compact>{
                                    pagesNotInCategory?.map((page: Page.IPage) => (
                                        <List.Item
                                            title={ page.title }
                                            abstract={ page.abstract }
                                            image={ page.abstractImage}
                                            linkTo={ page.slug }
                                            authorLinkTo="./frank"
                                            authorName="Dr. Frank Zickert"
                                            publishedAt={ timestampStringInEnglish(page.revision) }
                                            readingTime={ page.readingTime ?? undefined }
                                        />
                                    ))
                                }</List.Compact>
                            }
                            </Layout.Column>
                        
                        </Layout.Section>
                         */